import OrgAdminLayout from '../components/OrgAdminLayout';
import AuditLogExplorer from '../../components/audit/AuditLogExplorer';

// The firm's own audit trail — who changed what, who revealed a credential, and
// who was refused. Gated on `nav.audit-logs`, which an administrator grants from
// the Permissions matrix like every other section: it is not tied to a role, so
// a compliance partner or an office manager can hold it without also holding
// the rest of the cockpit.
//
// ⚠️ The sidebar entry is not the boundary. `/api/audit-logs` (hrms) and
// `/audit-logs` (auth-service) both enforce the same key, and both scope the
// rows to the caller's own organization from the TOKEN — never from a query
// parameter. Hiding the menu item alone would leave the data one curl away.
//
// Same component as `/admin/audit-logs`; `scope="firm"` drops the Organization
// column, which answers a question a firm reading its own trail never asks.

function OrgAdminAuditLogs() {
  return (
    <OrgAdminLayout
      title="Audit Logs"
      subtitle="Every high-value action in your firm — changes, reveals, and denials"
    >
      <AuditLogExplorer scope="firm" />
    </OrgAdminLayout>
  );
}

export default OrgAdminAuditLogs;
